var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full min-h-screen relative p-12 bg-white dark:bg-black"},[_c('masonry-layout',{attrs:{"images":_vm.stream}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }